<template>
    <div class="has-text-left has-text-white">
        <div class="notification is-primary" v-show="msgSentSucceed">
            <button class="delete" @click="msgSentSucceed = false"></button>
            Your contact form has been sent successfully! Please wait for our reply.
            <font-awesome-icon :icon="['fas', 'smile']" />
        </div>
        <div class="notification is-danger" v-show="msgSentError">
            <button class="delete" @click="msgSentError = false"></button>
            Oh no, something went wrong with the server, please try again a few minutes later.
            <font-awesome-icon :icon="['fas', 'frown']" />
        </div>


        <div class="field">
            <label class="label">Name *</label>
            <div class="control">
                <input class="input" type="text" placeholder="Jean-Luc Picard" v-model="name" @blur="v$.name.$touch()">
            </div>
            <p class="help is-danger" v-if="v$.name.$error">This name is required</p>
            </div>

            <div class="field">
            <label class="label">Email *</label>
            <div class="control">
                <input class="input" type="email" placeholder="makeitso@tng.com" v-model="email" @blur="v$.email.$touch()">
            </div>
            <p class="help is-danger" v-if="v$.email.$invalid || v$.email.$error">This email is invalid</p>
            </div>

            <div class="field">
                <label class="label">Subject *</label>
                <div class="control">
                    <div class="select is-dark">
                    <select v-model="selected">
                        <option disabled value="">Please select one</option>
                        <option>Order inquiry</option>
                        <option>Request HVC_{{ new Date().getFullYear() }}_catalog</option>
                        <option>Wish to connect</option>
                    </select>
                    </div>
                </div>
                <p class="help is-danger" v-if="v$.selected.$error">This selected is required.</p>
            </div>

            <div class="field">
            <label class="label">Message *</label>
            <div class="control">
                <textarea class="textarea" placeholder="There. are. four. lights." v-model="message" @blur="v$.message.$touch()"></textarea>
            </div>
            <p class="help is-danger" v-if="v$.message.$invalid || v$.email.$error">This message is required.</p>
            </div>

            <div class="field is-grouped is-grouped-right">
            <div class="control">
                <button class="button is-primary" @click="sendMsg">Submit</button>
            </div>
            <div class="control">
                <button class="button" @click="reset">Cancel</button>
            </div>
        </div>

    </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required, email } from '@vuelidate/validators'

export default {
  name: 'contact',
  setup: () => ({ v$: useVuelidate() }),
  data() {
    return {
        name: '',
        email: '',
        message: '',
        selected: '',
        msgSentSucceed: false,
        msgSentError: false,
    }
  },
  validations () {
    return {
      name: { required, $lazy: true },
      email: { required, email, $lazy: true },
      message: { required, $lazy: true },
      selected: { required }
    }
  },
  methods: {
    reset() {
        this.name = ''
        this.email= ''
        this.message = ''
        this.selected = ''
        this.v$.$reset()
    },
    async sendMsg() {
        const result = await this.v$.$validate()
        if (!result) {
            // notify user form is invalid
            return
        }

        var formData = new URLSearchParams();
        formData.append('name', this.name);
        formData.append('email', this.email);
        formData.append('message', this.message);
        formData.append('subject', this.selected);

        var authorizationBasic = window.btoa('29c559519b9d490c' + ':' + '9d654e33ac7b9fb5');

        fetch('https://hapi-bh4nw7zela-nn.a.run.app/v1/contact/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
                'Authorization': 'Basic ' + authorizationBasic
            },
            body: formData.toString()
        }).then(() => {
            this.msgSentSucceed = true
            this.reset()
        }).catch(() => {
            this.msgSentError = true
        })
    }
  }
}
</script>

<style>

</style>